import request from '../index';

export const getProfilesAvatars = () =>
  request({
    url: `/profiles/avatars`,
    method: 'GET',
  });

export const getProfile = (profileId) =>
  request({
    url: `/profiles/${profileId}?token=${localStorage.getItem('userToken')}`,
    method: 'GET',
  });

export const updateProfile = (profileId, profile) =>
  request({
    url: `/profiles/${profileId}`,
    data: profile,
    method: 'PUT',
  });

export const createProfile = (profile) =>
  request({
    url: `/profiles`,
    data: profile,
    method: 'POST',
  });

export const swtichProfile = (profileId) =>
  request({
    url: `/profiles/${profileId}/switch`,
    method: 'GET',
  });

export const getProfileFilter = () =>
  request({
    url: '/user_movie_filters',
    method: 'GET',
  });

export const setProfileFilter = (options) =>
  request({
    url: '/user_movie_filters',
    method: 'PATCH',
    data: options,
  });
